import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '~/features/legal/LegalPage';
import { TermsContent } from '~/features/legal/TermsContent';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

/** Terms of Service, public. The words live in TermsContent, which the build also turns into plain HTML. */
function TermsPage() {
  return (
    <LegalPage title="Terms of Service">
      <TermsContent />
    </LegalPage>
  );
}
